import { Text } from '@kanda-libs/ks-design-library';

import Container from './FinancePlan-container';
import { MoneyCard, TextCard } from './components';

export interface ViewComponentProps {
  /**
   * Price
   */
  total?: string | number;
  /**
   * Deposit value
   */
  deposit?: string | number;
  /**
   * Selected finance plan
   */
  plan?: string;
  /**
   * External className to apply to container
   */
  className?: string;
  /**
   * Prop to determine if the box should be shown
   */
  variant?: 'default' | 'noBox';
  /**
   * Prop to determine if the box should be shown
   */
  isLoading?: boolean;
}

const ViewComponent = ({ ...props }: ViewComponentProps) => (
  <Container {...props}>
    {({
      formattedTerm,
      deposit,
      monthly,
      total,
      fee,
      classNames,
      isLoading,
    }) => (
      <div className={classNames.container}>
        <Text
          isLoading={isLoading}
          text="Your plan"
          className={classNames.headingMobile}
          skeletonProps={{
            width: 80,
          }}
        />
        <div className={classNames.wrapper}>
          <Text
            isLoading={isLoading}
            text="Your plan"
            className={classNames.headingDesktop}
            skeletonProps={{
              width: 100,
            }}
          />
          <div className={classNames.grid}>
            <MoneyCard
              title="Monthly Payment"
              amount={monthly}
              classNames={classNames}
              isLoading={isLoading}
            />
            <MoneyCard
              title="Deposit"
              amount={deposit}
              classNames={classNames}
              isLoading={isLoading}
            />
            <TextCard
              title="Term"
              text={formattedTerm}
              classNames={classNames}
              isLoading={isLoading}
            />
            <MoneyCard
              title="Interest Fee"
              amount={fee}
              classNames={classNames}
              isLoading={isLoading}
            />
            <MoneyCard
              title="Total cost"
              amount={total}
              classNames={classNames}
              isLoading={isLoading}
            />
          </div>
        </div>
      </div>
    )}
  </Container>
);

ViewComponent.defaultProps = {
  total: undefined,
  deposit: undefined,
  plan: undefined,
  className: '',
  variant: 'default',
  isLoading: false,
};

ViewComponent.displayName = 'FinancePlan-view';

export default ViewComponent;
